<template>
    <div>
        <el-dialog title="新增推送" :visible.sync="visible" width="500px" :close-on-click-modal="false">
            <el-form :model="form" ref="form" :rules="rules" label-width="210px">
                <el-form-item label="请选择您想要新增的推送类型" prop="category">
                    <el-select v-model="form.category" style="width: 100%">
                        <el-option value="1" label="邮箱"></el-option>
                        <el-option value="3" label="站内信"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            form: {
                category: "",
            },
            rules: {
                category: [{ required: true, message: "请选择您想要新增的推送类型" }],
            },
        };
    },
    methods: {
        open() {
            this.visible = true;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                this.$router.push({ path: "/msg/list/form", query: { category: this.form.category } });
            });
        },
    },
};
</script>

<style></style>
